export const isCurrentlyOpen = (workingDaysAndHours) => {
    if (!workingDaysAndHours) return false;

    const now = new Date();
    const dayName = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][now.getDay()];
    const currentHours = workingDaysAndHours[dayName];

    if (!currentHours) return false;

    // Handle object format
    if (typeof currentHours === 'object' && currentHours.open && currentHours.close) {
        const [openH, openM] = currentHours.open.split(':').map(Number);
        const [closeH, closeM] = currentHours.close.split(':').map(Number);
        const currentTime = now.getHours() * 60 + now.getMinutes();
        return currentTime >= (openH * 60 + openM) && currentTime < (closeH * 60 + closeM);
    }

    // Handle string format
    const timeMatch = String(currentHours).match(/(\d{1,2}):(\d{1,2})\s*-\s*(\d{1,2}):(\d{1,2})/);
    if (!timeMatch) return false;

    const openTime = parseInt(timeMatch[1]) * 60 + parseInt(timeMatch[2]);
    const closeTime = parseInt(timeMatch[3]) * 60 + parseInt(timeMatch[4]);
    const currentTime = now.getHours() * 60 + now.getMinutes();

    return currentTime >= openTime && currentTime < closeTime;
};
